import { useMemo } from 'react';
import {
  FingoChristmas,
  FingoLogo,
  FingoChile,
  FingoHalloween,
} from '../assets';
import dayjs from '../config/dayjs';
import { REQUESTING_PLATFORM_TO_CODES } from '../constants/requesting-platform';
import BancoDeChileLogoBlue from '../assets/icons/logos/banco_de_chile_blue';

const requestingPlatform = process.env.REACT_APP_ACTIVE_REQUESTING_PLATFORM;

const getFingoDynamicLogo = () => ({
  9: FingoChile,
  10: FingoHalloween,
  12: FingoChristmas,
}[dayjs().format('M')] || FingoLogo);

const bchDynamicLogos = () => BancoDeChileLogoBlue;

const dynamicLogos = {
  [REQUESTING_PLATFORM_TO_CODES.FINGO]: getFingoDynamicLogo,
  [REQUESTING_PLATFORM_TO_CODES.BCH]: bchDynamicLogos,
};

const useDynamicFingoLogo = () => useMemo(
  () => dynamicLogos[requestingPlatform]?.() || getFingoDynamicLogo(),
  [],
);
export default useDynamicFingoLogo;
